<template>
  <div class="pp-stack" data-test="pp-tab-followups">
    <PanelCard title="Follow-ups" icon="fa-bell-o" :count="openCount ? `${openCount} open` : '—'" test-id="pp-followups">
      <FollowupList :rows="followups" :date-format="dateFormat" />
    </PanelCard>
  </div>
</template>

<script>
/**
 * Follow-ups — read-only rows (design 1a). The Schedule View panel shows this once
 * /schedule-view/patient carries the rows; until then the tab is disabled (PatientProfileView).
 * The Patient Profile page replaces this body with the editable FollowupsProfileSection.
 *
 * ⛔ No prop named `patNum`, `siteID` or `loading` — mixin.js computeds silently replace them.
 */
import PanelCard from '../PanelCard.vue';
import FollowupList from '../FollowupList.vue';

export default {
  name: 'FollowupsTab',

  components: { PanelCard, FollowupList },

  props: {
    followups: { type: Array, default: () => [] },
    today: { type: String, default: '' },
    dateFormat: { type: String, default: 'MM/DD/YYYY' },
  },

  computed: {
    openCount() {
      return this.followups.filter(f => f && f.FollowupDate).length;
    },
  },
};
</script>
